import React from "react";
import { footerLinks, companyInfo } from "./footer.constants";
import { FooterProps } from "./footer.types";

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className="bg-slate-100 text-gray-700 text-sm">
      <div className="max-w-7xl mx-auto px-4 pt-6 pb-4">
        <div className="flex justify-center space-x-20  pb-4">
          {footerLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="hover:underline font-medium text-[#6F6F6F]"
            >
              {link.label}
            </a>
          ))}
        </div>
        <div className="flex flex-col md:flex-row justify-between pt-4">
          <div className="text-[#2E2E2E] text-sm">
            <p>{companyInfo.name}</p>
            <p>{companyInfo.address}</p>
          </div>
          <p className="mt-2 md:mt-0 text-[#2E2E2E] text-sm">
            &copy; {new Date().getFullYear()} {companyInfo.name}. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
